import core from "@gtmhub/core/module";
import { GlobalSearchService } from "@gtmhub/search/services/globalSearchService";
import { GlobalSearchComponent, GlobalSearchCtrl } from "@gtmhub/search/components/global-search/global-search";
import { GlobalSearchV2Component, GlobalSearchV2Ctrl } from "@gtmhub/search/components/global-search-v2/global-search-v2.component";
import { SimpleGlobalSearchComponent, SimpleGlobalSearchCtrl } from "@gtmhub/search/components/simple-global-search/simple-global-search";
import { NoSearchItemsFoundComponent } from "@gtmhub/search/components/no-search-items-found/no-search-items-found.component";
import { InsightRedirectModalCtrl, InsightRedirectModalService } from "@gtmhub/search/components/insight-redirect-modal/insight-redirect-modal";
import { GlobalSearchItemComponent } from "@gtmhub/search/components/global-search-item/global-search-item.component";
import { GlobalSearchStateWrapperComponent, GlobalSearchStateWrapperCtrl } from "@gtmhub/search/components/global-search-state-wrapper/global-search-state-wrapper";
import { InsightRedirectModalCtrlComponent } from "./components/insight-redirect-modal/insight-redirect-modal";

const mod = angular.module("search", [core]);
mod.service("GlobalSearchService", GlobalSearchService);
mod.service("InsightRedirectModalService", InsightRedirectModalService);
mod.controller("GlobalSearchCtrl", GlobalSearchCtrl);
mod.controller("GlobalSearchV2Ctrl", GlobalSearchV2Ctrl);
mod.controller("SimpleGlobalSearchCtrl", SimpleGlobalSearchCtrl);
mod.controller("InsightRedirectModalCtrl", InsightRedirectModalCtrl);
mod.controller("GlobalSearchStateWrapperCtrl", GlobalSearchStateWrapperCtrl);
mod.component("ghSimpleSearch", SimpleGlobalSearchComponent);
mod.component("ghSearch", GlobalSearchComponent);
mod.component("ghSearchV2", GlobalSearchV2Component);
mod.component("ghSearchItem", GlobalSearchItemComponent);
mod.component("ghSearchStateWrapper", GlobalSearchStateWrapperComponent);
mod.component("noSearchItemsFound", NoSearchItemsFoundComponent);
mod.component("insightRedirectModal", InsightRedirectModalCtrlComponent);

export default mod.name;
